export default "__VITE_ASSET__2bi92bRw__"